import { Component, OnInit } from '@angular/core';
import { tenantInfo } from 'src/app/Models/url';

@Component({
  selector: 'app-contact-location',
  templateUrl: './contact-location.component.html',
  styleUrls: ['./contact-location.component.css']
})
export class ContactLocationComponent implements OnInit {

  tenantInfo: any = tenantInfo;

  constructor() { }

  ngOnInit(): void {
  }

}
